module.exports = {
  text: `Я знаю что не создавал драконьих черепах и Тиамат клянётся что тоже их не создавала. Тогда откуда же они взялись? И, что важнее — зачем?`,
  author: `Физбан`,
}
